module.exports = __webpack_public_path__ + "86a3e1dc71a06f96565f1d8e581395a1.pdf";